<template>
  <div
    class="card my-2"
    :class="this.selected ? 'bmg-opacity-100' : 'bmg-opacity-50'"
  >
    <div class="d-flex justify-content-center mt-3">
      <div
        class="rounded w-90"
        :class="pic"
      />
    </div>
    <div class="text-center m-2">
      <p class="h1 font-weight-bold mt-4 mb-3 text-dark">
        {{ name }}
      </p>
      <p class="h3 text-primary">
        <strong>{{ title }}</strong>
      </p>
      <p
        v-if="showBio"
        class="grey-text font-weight-bold"
      >
        {{ bio }}
      </p>
      <p
        v-if="phone"
        class=""
      >
        <span class="">Cell: </span><a
          class="externalLinksGoogleTracking"
          :tracking-info="'Phone Link for ' + name"
          :href="'tel:'+ phone"
        >{{ phone }}</a>
      </p>
      <p
        v-if="email"
        class=""
      >
        <a
          class="externalLinksGoogleTracking"
          :tracking-info="'Email Link for' + name"
          :href="'mailto:'+ email"
        >{{ email }}</a>
      </p>
      <!-- Calendly link widget begin -->
      <!-- v-on:click="Calendly.initPopupWidget({url: this.calendlyPopup()});return false;"> -->
      <div
        v-if="calendly"
        class="w-100 pointer text-white bg-primary font-weight-bold"
        @click.stop="calendlyPopup()"
      >
        <u>Schedule time with me</u>
      </div>
      <!-- <a v-if="calendly" href=""
        onclick="Calendly.initPopupWidget({url: 'https://calendly.com/aaron-patty?background_color=002939&text_color=FFFFFF&primary_color=097cab'});return false;">
        Schedule time with me
      </a> -->
      <!-- Calendly link widget end -->
      <p class="text-white bg-grey mt-2">
        Resides in {{ location }}
      </p>
    </div>
  </div>
</template>

<script>
// import Calendly from './CalendlyOriginal.js'

export default {
  name: 'BioCard',
  props: [
    'name',
    'title',
    'bio',
    'pic',
    'email',
    'phone',
    'location',
    'selected',
    'showBio',
    'calendly'
  ],
  data: function () {
    return {
    }
  },
  components: {},
  methods: {
    calendlyPopup: function () {
      // debugger
      var _url = 'https://calendly.com/' + this.calendly + '?background_color=FFFFFF&text_color=002939&primary_color=097cab'
      // var _url = 'https://calendly.com/' + this.calendly + '?background_color=002939&text_color=FFFFFF&primary_color=097cab'
      // console.log('calendly _url', _url)
      // console.log('Calendly', window.Calendly)
      window.Calendly.initPopupWidget({
        url: _url
      })

      return false
    }
  },
  computed: {

  },
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
